import {observable, action, makeObservable} from "mobx";

class AdminStore {
    sites = undefined;
    submissions = undefined;
    users = undefined;
    projects = undefined;
    project = {};
    emails = undefined;
    email = {};
    teamMembers = undefined;

    constructor() {
        makeObservable(this, {
            sites: observable,
            submissions: observable,
            users: observable,
            projects: observable,
            project: observable,
            emails: observable,
            email: observable,
            teamMembers: observable,

            setSites: action,
            setSubmissions: action,
            setUsers: action,
            setProjects: action,
            setProject: action,
            setEmails: action,
            setEmail: action,
            setTeamMembers: action,
        })
    }

    initialize() {
        this.sites = undefined;
        this.project = {};
    }

    setSites(sites) {
        this.sites = sites;
    }

    setUsers(users) {
        this.users = users;
    }

    setSubmissions(submissions) {
        this.submissions = submissions;
    }

    setProjects(projects) {
        this.projects = projects;
    }

    setProject(project) {
        this.project[project.job_id] = project;
    }

    setEmails(emails) {
        this.emails = emails;
    }

    setEmail(email) {
        this.email[email.email_id] = email;
    }

    setTeamMembers(members) {
        this.teamMembers = members;
    }
};


export default new AdminStore();
